import { render } from "./ViewJobUser.vue?vue&type=template&id=5708a38f&scoped=true"
import script from "./ViewJobUser.vue?vue&type=script&lang=js"
export * from "./ViewJobUser.vue?vue&type=script&lang=js"

import "./ViewJobUser.vue?vue&type=style&index=0&id=5708a38f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5708a38f"]])

export default __exports__